import { useEffect, useState } from "react";
import { db, storage } from "../components/firebase.js";
import checkCarAvailability from "./CarAvailability.jsx";
import BgShape from "../images/hero/bookbg.jpg";
import {
  doc,
  getDocs,
  setDoc, getDoc,
  onSnapshot, query,where,
  collection,
  addDoc, updateDoc
} from "firebase/firestore";
import PhoneInput from "react-phone-number-input";
import "./numberinput.css"; // Import your custom styles
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import emailjs from "@emailjs/browser";
import { v4 as uuidv4 } from "uuid"; // To generate unique session ID

import { loadStripe } from "@stripe/stripe-js";

//import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";



function BookCar({ carName }) {

  const [modal, setModal] = useState(false); //  class - active-modal
  const [car, setCar] = useState("");
  const [pickUp, setPickUp] = useState("");
  const [dropOff, setDropOff] = useState("");
  const [pickTime, setPickTime] = useState("");
  const [dropTime, setDropTime] = useState("");
  const [days, setDays] = useState("abc");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [pickingTime, setPickingTime] = useState("");
  const [droppingTime, setDroppingTime] = useState("");
  const [insurance, setInsurance] = useState("");

  

const [status, setStatus] = useState(null);

  useEffect(() => {
    const fetchPauseStatus = async () => {
      try {
        const docRef = doc(db, 'pause', 'doc001');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setStatus(data.status); // status should be 'pause' or 'resume'
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching status:', error);
      }
    };

    fetchPauseStatus();

    console.log(status)
  }, [status]);


  // taking value of modal inputs
  const handleName = (e) => {
    setName(e.target.value);
  };

  const handleLastName = (e) => {
    setLastName(e.target.value);
  };

  const handlePhone = (e) => {
    setPhone(e.target.value);
  };

  const handleAge = (e) => {
    setAge(e.target.value);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleAddress = (e) => {
    setAddress(e.target.value);
  };

  const handleInsurance = (e) => {
    setInsurance(e.target.value);
  };

  const customCardStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: "Arial, sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };


  const [totalPrice, setTotalPrice] = useState(0); // Total rental price

  const calculateTotalPrice = () => {
    let rate = 0;
    let ins = 0;
  
    // Automatically set insurance to "Yes" if it's empty
   
  
    // Calculate rate based on vehicle type and number of days
    if (car === "Compact") {
      if (days === 1) rate = 55;
      else if (days >= 2 && days <= 5) rate = 50;
      else if (days >= 6) rate = 39;
    } else if (car === "MidSize") {
      if (days === 1) rate = 65;
      else if (days >= 2 && days <= 5) rate = 55;
      else if (days >= 6) rate = 50;
    } 

    else if (car === "Jeep") {
      if (days === 1) rate = 175;
      else if (days >= 2 && days <= 5) rate = 175;
      else if (days >= 6) rate = 150;
    } 
    
    else if (car === "FullSize") {
      if (days === 1) rate = 75;
      else if (days >= 2 && days <= 5) rate = 65;
      else if (days >= 6) rate = 60;
    } else if (car === "Minivan") {
      if (days === 1) rate = 85;
      else if (days >= 2 && days <= 5) rate = 75;
      else if (days >= 6) rate = 65;
    } else if (car === "Scooter") {
      rate = 55; // Fixed rate for Scooter
      if (days === 1) {
        ins = 9.95; // Mandatory 1-day insurance
        if (insurance === "No") {
          setInsurance("Yes"); // Automatically set insurance to "Yes" for 1-day rentals
          window.alert("Insurance is Mandatory for 1 day rental. It has been updated in total.")
        }
      } else {
        ins = insurance === "Yes" ? 9.95 : 0; // Optional insurance for more than 1 day
      }
    }
  
    // Apply insurance cost for non-scooter vehicles
    if (car !== "Scooter") {
      if (insurance === "Yes") {
        ins = 15;
      } else if ((insurance === "No" || insurance === "") && days === 1) {
        ins = 15; // Mandatory insurance for 1 day rental
        setInsurance("Yes");
        window.alert("Insurance is Mandatory for 1 day rental. It has been updated in total.")
      } else {
        ins = 0;
      }
    }

    if (car === "Jeep") {
      if (insurance === "Yes") {
        ins = 20;
      } else if ((insurance === "No" || insurance === "") && days === 1) {
        ins = 20; // Mandatory insurance for 1 day rental
        setInsurance("Yes");
        window.alert("Insurance is Mandatory for 1 day rental. It has been updated in total.")
      } else {
        ins = 0;
      }
    }




  
    // Calculate total price
    const total = rate * days + ins * days;
   // const totalz = total + total*0.1;
   const totalz = parseFloat((total + total * 0.1).toFixed(2));
    setTotalPrice(totalz);
  };

 const [availabilityMessage, setAvailabilityMessage] = useState("");

  // Maximum cars allowed per category
  const maxCars = {
    Compact: 9,
    FullSize:3,
    MidSize:6,
    Minivan:3,
    Scooter:10,
    Jeep:1
  };

  const checkAvailability = async () => {
    try {
      // Validate input dates
      if (!pickTime || !dropTime) {
        window.alert("Please select valid pick-up and drop-off dates.");
        return false;
      }
  
      // Parse input dates
      const pickDate = new Date(pickTime);
      const dropDate = new Date(dropTime);
  
      if (pickDate > dropDate) {
        window.alert("Pick-up date must be before the drop-off date.");
        return false;
      }
  
      // Fetch bookings for the selected car category
      const bookingsRef = collection(db, "BullesEyebookingsdata");
      const bookingsQuery = query(bookingsRef, where("carname", "==", car));
      const snapshot = await getDocs(bookingsQuery);
  
      // Filter bookings with overlapping date ranges
      const filteredBookings = snapshot.docs.filter((doc) => {
        const data = doc.data();
        const bookingPickTime = new Date(data.picktime);
        const bookingDropTime = new Date(data.droptime);
  
        return bookingPickTime <= dropDate && bookingDropTime >= pickDate;
      });
  
      console.log(`Number of overlapping bookings: ${filteredBookings.length}`);
  
      // Check availability
      if (filteredBookings.length < maxCars[car]) {
        setAvailabilityMessage(`Booking slot available for ${car}`);
        return true; // Available
      } else {
        window.alert(`Bookings for ${car} are full in the selected date range.`);
        setAvailabilityMessage("");
        return false; // Not available
      }
    } catch (error) {
      console.error("Error checking car availability:", error);
      return false;
    }
  };
  


  // open modal when all inputs are fulfilled
  const openModal = async (e) => {
    e.preventDefault();
    const errorMsg = document.querySelector(".error-message");

   // console.log('Stripe Secret Key:', process.env.REACT_APP_STRIPE_SECRET_KEY);
  
    // Check availability




    // Requested to pause bookings on June 13 July
 // window.alert('Online Bookings are temporarily paused on request of website owners. Please call or email for any further inquiry.')
 //return;


          if (status === 'pause') {
            window.alert('Online Bookings are temporarily paused on request of website owners. Please call or email for any further inquiry.');
            return;
          }

    if (pickingTime <= "06:59" || pickingTime >= "21:01") {
      window.alert("Our pickup/dropoff times are 7am to 9pm, please choose your pickup/dropoff time accordingly!");
      return;
    }

    const isAvailable = await checkAvailability();
  
    // Stop modal opening if bookings are full
    if (!isAvailable) return;

    let pickTimez = new Date(pickTime);
    let dropTimez = new Date(dropTime);

    // Check if the conversion was successful
    if (isNaN(pickTimez.getTime()) || isNaN(dropTimez.getTime())) {
      console.error("Invalid date format");
      return;
    }

    // Calculate the time difference in milliseconds
    let timeDifference = dropTimez.getTime() - pickTimez.getTime();

    // Convert time difference from milliseconds to days
    let dayDifference = timeDifference / (1000 * 3600 * 24);

    setDays(dayDifference);

   

    calculateTotalPrice();

    if (insurance === "") {
      setInsurance("Yes");
     
    }
  
    // Check if all fields are filled
    if (
      !pickUp ||
      !dropOff ||
      !pickTime ||
      !dropTime ||
      !car ||
      !pickingTime
    ) {
      errorMsg.style.display = "flex";
    } else {
      setModal(!modal);
      const modalDiv = document.querySelector(".booking-modal");
      modalDiv.scroll(0, 0);
      errorMsg.style.display = "none";
    }
  };


  useEffect(() => {

    if (days === 0) {
      window.alert("Same Pickup and Dropoff date is selected, please select a dropoff date after the pickup date.");
      setModal(false);
      setDays('abcd')
      return;
    }

  }, [days, dropTime]);




  // disable page scroll when modal is displayed
  useEffect(() => {
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modal]);

  // confirm modal booking

  const handleTimeChange = (e) => {
    setPickingTime(e.target.value);
  };

  const handleTimeChange2 = (e) => {
    setDroppingTime(e.target.value);
  };

  const convertTo12HourFormat = (timeString) => {
    const [hour, minute] = timeString.split(":");
    const parsedHour = parseInt(hour, 10);
    const ampm = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour % 12 === 0 ? 12 : parsedHour % 12;
    return `${formattedHour}:${minute} ${ampm}`;
  };

  const [images, setImages] = useState([]); // State for selected images
  const [imageURLs, setImageURLs] = useState([]); // State for image URLs

  // Function to handle image selection
  const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files).slice(0, 2); // Limit to 2 images
    setImages(selectedFiles);

    // Create image URLs for preview
    const imageURLs = selectedFiles.map((file) => URL.createObjectURL(file));
    setImageURLs(imageURLs);
  };

  // Function to upload images and return their download URLs
  const uploadImages = async () => {
    const imageUploadPromises = images.map(async (image) => {
      const storageRef = ref(storage, `images/${image.name}`);
      await uploadBytes(storageRef, image);
      return await getDownloadURL(storageRef);
    });

    return await Promise.all(imageUploadPromises);
  };

  const [loading, setLoading] = useState(false); // Loading state for the loader

  const sendEmail = () => {
    const templateParams = {
      type: "Car Booking",
    };

    emailjs
      .send(
        "service_4hq7nj6",
        "template_2evjksn",
        templateParams,
        "Nst7XlaMXOHkmgyS1"
      )
      .then(
        (response) => {
          console.log(
            "Email sent successfully:",
            response.status,
            response.text
          );
        },
        (error) => {
          console.error("Failed to send message:", error.text);
        }
      );
  };

  useEffect(() => {
    calculateTotalPrice();
  }, [car, pickUp, dropOff, pickTime, dropTime, days]);


  const stripeSecretKey = process.env.REACT_APP_STRIPE_SECRET_KEY; // Secret Key from .env
  //const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY; // Publishable Key

  function generateSessionId() {
    return 'session-' + Math.random().toString(36).substr(2, 9); // Example random session ID generation
  }
  
 const postBooking = async () => {
  try {

  
    if (!name || !age || !phone || !email || !address) {
      window.alert("Error: Fill All Fields!");
      return;
    }


   if (age < 25) {
  window.alert("Only Customers Aged 25 Or Above Are Allowed To Rent A Car");
  return;
}


    if (images.length === 0) {
      window.alert("Error: Also attach driving license image");
      return;
    }

    
     setLoading(true);

    const formattedTime = convertTo12HourFormat(pickingTime);
    const formattedTime1 = convertTo12HourFormat(droppingTime);

    // Upload images and get their download URLs
    const imageDownloadURLs = await uploadImages();
    // console.log("Uploaded images:", imageDownloadURLs);

    // Create or retrieve browser session ID
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = generateSessionId(); // Function to generate a unique session ID if needed
      sessionStorage.setItem('sessionId', sessionId); // Store session ID for future use
    }

    // Create a Stripe Checkout Session

    console.log("Creating Stripe Checkout session...");



    // being commented from here 26 aug 2026 for security  key fix



    
    const stripeResponse = await fetch("https://api.stripe.com/v1/checkout/sessions", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${stripeSecretKey}`, // Use your secret key
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        // payment_method_types: "card", // Set payment methods
        mode: "payment",
        success_url: `http://bullseyeenterprises242.com/successful-payment?session_id=${sessionId}`, // Add session_id placeholder
        //cancel_url: "http://localhost:3000", // Replace with your cancel URL
        // Dynamic price data
        "line_items[0][price_data][currency]": "usd",
        "line_items[0][price_data][product_data][name]": "Car Rental Booking",
        "line_items[0][price_data][unit_amount]": totalPrice * 100, // Convert to cents
        "line_items[0][quantity]": 1, // Always 1 item
      }),
    });

    const sessionData = await stripeResponse.json();

    console.log("Stripe response:", sessionData);

    if (!stripeResponse.ok) {
      console.error("Stripe API error:", sessionData.error);
      throw new Error(sessionData.error?.message || "Error creating payment session");
    }


    const paymentUrl = sessionData.url;

    // Save booking data to Firestore along with the session ID
    console.log("Saving booking data to Firestore...");
    await addDoc(collection(db, "BullesEyebookingsdata"), {
      carname: car,
      insurance: insurance,
      quote: totalPrice,
      pickup: pickUp,
      dropoff: dropOff,
      picktime: pickTime,
      droptime: dropTime,
      pickingtime: formattedTime,
      droppingtime: formattedTime,
      name: name,
      phone: phone,
      age: age,
      email: email,
      address: address,
      paymentStatus: "pending",
      images: imageDownloadURLs,
      sessionId: sessionId,
      date: new Date().toISOString().split("T")[0], 
      disbtn:"no",

      
    });
    console.log("Booking data saved successfully.");

    // Redirect the user to the Stripe Checkout page
    console.log("Redirecting to Stripe Checkout:", paymentUrl);
    window.location.href = paymentUrl;
  } catch (error) {
    console.error("Error adding document or creating payment link:", error);
    window.alert(`Error: ${error.message}`);
    setLoading(false);
  } finally {
    setLoading(false); 
  }
};

// Function to generate a unique session ID if needed
function generateSessionId() {
  return 'session-' + Math.random().toString(36).substr(2, 9); // Example random session ID generation
}


 


  const confirmBooking = (e) => {
    e.preventDefault();
    postBooking();
  };

  // taking value of booking inputs

  const handlePick = (e) => {
    setPickUp(e.target.value);
  };

  const handleCar = (e) => {
    setCar(e.target.value);
  };

  const handleDrop = (e) => {
    setDropOff(e.target.value);
  };

  const handlePickTime = (e) => {
    setPickTime(e.target.value);
  };

  const handleDropTime = (e) => {
    setDropTime(e.target.value);
  };

  const formattedTimes = convertTo12HourFormat(pickingTime);
  const formattedTimes1 = convertTo12HourFormat(droppingTime);
  // hide message
  const hideMessage = () => {
    const doneMsg = document.querySelector(".booking-done");
    doneMsg.style.display = "none";
  };

  const bgImageStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  };

  return (
    <>
      <section
        id="booking-section"
        className="book-section"
        style={{ position: "relative", zIndex: "24", marginTop:'-96px' }}
      >
        {/* overlay */}
        <img src={BgShape} alt="Background Shape" style={bgImageStyle} />
        <div
          onClick={openModal}
          className={`modal-overlay ${modal ? "active-modal" : ""}`}
        ></div>

        {/*  <div className="plan-container__title" style={{ position: "absolute"}}>
          <h2 style={{position: "absolute", textAlign:'center'}}>Reserve Your Car</h2>
        </div> */}

        <div className="container">
          <div className="book-content">
            <div
              className="book-content__box"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.65)", // 20% opacity for the background color
                // backgroundImage: 'linear-gradient(315deg, rgba(0, 153, 14, 0.2) 0%, rgba(77, 212, 18, 0.2) 74%)', // 20% opacity for the gradient
              }}
            >
              <div className="plan-container__title">
                <h2
                  style={{
                    color: "yellow",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Book Your Vehicle{" "}
                </h2>
              </div>

              <p className="error-message">
                All fields required! <i className="fa-solid fa-xmark"></i>
              </p>
              <p className="booking-done">
                Your booking is saved! {" "}
                <i onClick={hideMessage} className="fa-solid fa-xmark"></i>
              </p>
              <form className="box-form">
                <div className="box-form__car-type">
                  <label style={{ color: "yellow" }}>
                    <i className="fa-solid fa-car"></i> &nbsp; Select Your Vehicle
                    Type <b>*</b>
                  </label>

                  <select
                    value={car}
                    onChange={handleCar}
                    style={{ color: "#444443" }}
                  >
                    <option>Select Vehicle Type</option>
                    <option>Compact</option>
                    <option>MidSize</option>
                    <option>FullSize</option>
                     <option>Jeep</option>
                    <option>Minivan</option>
                    <option>Scooter</option>
                  </select>
                </div>
                <div className="box-form__car-type">
                  <label style={{ color: "yellow" }}>
                    <i className="fa-solid fa-location-dot"></i> Pick-up{" "}
                    <b>*</b>
                  </label>
                  <select
                    value={pickUp}
                    onChange={handlePick}
                    style={{ color: "#444443" }}
                  >
                    <option>Select pick up location</option>
                    <option>Main Office</option>
                    <option>Port Lucaya </option>
                    <option>Airport </option>
                    <option>Harbour</option>
                  </select>
                </div>

                <div className="box-form__car-type">
                  <label style={{ color: "yellow" }}>
                    <i className="fa-solid fa-location-dot"></i> Drop-off{" "}
                    <b>*</b>
                  </label>

                  <select
                    value={dropOff}
                    onChange={handleDrop}
                    style={{ color: "#444443" }}
                  >
                    <option>Select drop off location</option>
                    <option>Main Office</option>
                    <option>Port Lucaya </option>
                    <option>Airport </option>
                    <option>Harbour</option>
                  </select>
                </div>

                <div className="box-form__car-type">
                  <label style={{ color: "yellow" }}>
                    <i className="fa-solid fa-location-dot"></i> Get Insurance? ($15/day){" "}
                    <b>*</b>
                  </label>

                  <select
                    value={insurance}
                    onChange={handleInsurance}
                    style={{ color: "#444443" }}
                  >
                  {/*  <option>Choose Option</option> */}  
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>



                <div className="box-form__car-time">
                  <label htmlFor="picktime" style={{ color: "yellow" }}>
                    <i className="fa-regular fa-calendar-days "></i>
                    Pick-up Date <b>*</b>
                  </label>
                  <input
                    id="picktime"
                    value={pickTime}
                    onChange={handlePickTime}
                    type="date"
                  ></input>

                  <label
                    htmlFor="droptime"
                    style={{ marginTop: "13px", color: "yellow" }}
                  >
                    Pick-up Time <b>*</b>
                  </label>
                  <input
                    id="droptime"
                    value={pickingTime}
                    onChange={handleTimeChange}
                    type="time"
                    className="input-time"
                    style={{ width: "150px" }}
                  />
                </div>

                <div className="box-form__car-time">
                  <label htmlFor="droptime" style={{ color: "yellow" }}>
                    <i className="fa-regular fa-calendar-days "></i>
                    Drop-of Date <b>*</b>
                  </label>
                  <input
                    id="droptime"
                    value={dropTime}
                    onChange={handleDropTime}
                    type="date"
                  ></input>

                  <label
                    htmlFor="droptime"
                    style={{ marginTop: "13px", color: "yellow" }}
                  >
                    Drop-off Time <b>*</b>
                  </label>

                  <p
                    style={{
                      backgroundColor: "white",
                      height: "23px",
                      textAlign: "center",
                      fontSize: "15px",
                    }}
                  >
                    {" "}
                    Same time as pickup time
                  </p>

                </div>
              </form>

              <button
                onClick={openModal}
                type="submit"
                style={{
                  alignSelf: "center",
                  width: "260px",
                  marginTop: "14px",
                  background:
                    "linear-gradient(175deg, #f7e9a0, #ffcc00, #d4af37, #b8860b)",
                  backgroundSize: "200% 200%",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",

                  // borderRadius: '10px',
                  color: "white",
                  textAlign: "center",
                  animation: "shine 3s infinite linear",
                  //backgroundImage: 'linear-gradient(275deg, #00690a 0%, #3a9e0e 79%)',
                  //transition: "box-shadow 0.3s ease-in-out",

                  borderRadius: "33px",
                }}
              >
                 Book Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* modal ------------------------------------ */}
      <div
        className={`booking-modal ${modal ? "active-modal" : ""}`}
        style={{ zIndex: "24" }}
      >
        {/* title */}
        <div
          className="booking-modal__title"
          style={{
            backgroundColor: "#5078f2",
            backgroundImage: "linear-gradient(315deg, #182b3a 0%, #20a4f3 74%)",
          }}
        >
          <h2>Complete Reservation</h2>
          <i onClick={openModal} className="fa-solid fa-xmark"></i>
        </div>
        {/* message */}
        <div className="booking-modal__message">
          <h4 style={{ color: "blue" }}>
            <i className="fa-solid fa-circle-info"></i> Upon completing this
            reservation enquiry:
          </h4>
          <p>
            You will be redirected to the payment page. Your booking will be confirmed only in case of successful payment.
          </p>
        </div>
        {/* car info */}
        <div className="booking-modal__car-info">
          <div className="dates-div">
            <div className="booking-modal__car-info__dates">
              <h5 style={{ color: "blue" }}>Location & Date</h5>
              <span>
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h6>Pick-Up Date & Time</h6>
                  <p>
                    {pickTime} / {formattedTimes}
                  </p>
                </div>
              </span>
            </div>
            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h6>Drop-Off Date & Time</h6>
                  <p>
                    {dropTime} / {formattedTimes}
                  </p>
                </div>
              </span>
            </div>
            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>Pick-Up Location</h6>
                  <p>{pickUp}</p>
                </div>
              </span>
            </div>
            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>Drop-Off Location</h6>
                  <p>{dropOff}</p>
                </div>
              </span>
            </div>
          </div>
          <div className="booking-modal__car-info__model">
            <h5 style={{ color: "blue" }}>Pricing</h5>

            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>Insurance?</h6>
                  <p>{insurance}</p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>Days Rented</h6>
                  <p>{days}</p>
                </div>
              </span>
            </div>

            <div className="booking-modal__car-info__dates">
              <span>
                <i className="fa-solid fa-calendar-days"></i>
                <div>
                  <h6>Total Quote (VAT Inclusive)</h6>
                  <p style={{ fontWeight: "bold", color: "green" }}>
                    ${totalPrice}
                  </p>
                </div>
              </span>
            </div>
          </div>
        </div>
        {/* personal info */}
        <div className="booking-modal__person-info">
          <h4 style={{ color: "blue" }}>Personal Information</h4>
          <form className="info-form">
            <div className="info-form__2col">
              <span>
                <label>
                  Full Name <b>*</b>
                </label>
                <input
                  value={name}
                  onChange={handleName}
                  type="text"
                  placeholder="Enter full name"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              <span>
                <label>
                  Age <b>*</b>
                </label>
                <input
                  value={age}
                  onChange={handleAge}
                  type="number"
                  placeholder="Enter age"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>

             
              <span>
                <div className="phoneInputContainer">
                  <label className="label">
                    Phone Number <b>*</b>
                  </label>
                  <div className="phoneInputWrapper">
                    <PhoneInput
                      international
                      defaultCountry="US"
                      value={phone}
                      onChange={setPhone}
                      placeholder="Enter your phone number"
                      className="phoneInput"
                    />
                  </div>
                  <p className="error-modal">This field is required.</p>
                </div>
              </span>

              
            </div>
            <div className="info-form__1col">
              <span>
                <label>
                  Email <b>*</b>
                </label>
                <input
                  value={email}
                  onChange={handleEmail}
                  type="email"
                  placeholder="Enter your email address"
                ></input>
                <p className="error-modal">This field is required.</p>
              </span>

              <span>
                <label>
                  Address <b>*</b>
                </label>
                <input
                  value={address}
                  onChange={handleAddress}
                  type="text"
                  placeholder="Enter your address"
                ></input>
                <p className="error-modal ">This field is required.</p>
              </span>
            </div>

            <div className="info-form__2col">
              <span>
                <label>
                  Upload driving license picture <b>*</b>
                </label>
                {/* Input fields for booking data */}

                {/* Image selection and preview */}
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleImageChange}
                />
                <div
                  style={{ display: "flex", gap: "10px", marginTop: "10px" }}
                >
                  {imageURLs.map((url, index) => (
                    <img
                      key={index}
                      src={url}
                      alt={`Selected ${index}`}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                    />
                  ))}
                </div>
              </span>
            </div>

            
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto', lineHeight: '1.6' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Terms and Conditions</h1>
      <ol style={{ fontSize: '12px', fontWeight: 'normal' }}>
        <li>
          LOSS DAMAGE WAIVER (LDW) DOES NOT APPLY TO DAMAGE CAUSED BY OFF THE ROAD USE, DAMAGE TO THE INTERIOR, AND DAMAGE TO VEHICLES CAUSED BY COLLISION WITH STATIONARY OR OVERHEAD OBJECTS.
        </li>
        <li>
          RENTER IS LIABLE FOR ALL DAMAGE AND COSTS TO VEHICLE CAUSED BY A DRIVER NOT NAMED IN THIS AGREEMENT, EVEN IF RENTER HAS PURCHASED LDW.
        </li>
        <li>
          RENTER AGREES TO PAY ALL PARKING TICKETS, TRAFFIC VIOLATIONS, AND TOLL ROAD CHARGES INCURRED AND BE LIABLE FOR A SERVICE CHARGE FOR EACH TICKET AND/OR VIOLATION PLUS ALL PARKING AND TRAFFIC FINES AND TOLL ROAD CHARGES.
        </li>
        <li>
          NO PARKING VIOLATION INCURRED DURING RENTAL.
        </li>
        <li>
          No Smoking allowed in the car. Any evidence of smoking in the car will lead to a penalty of $350.
        </li>
        <li>
          RETURN DATE CONFIRMATION.
        </li>
        <li>
          IF THIS RENTAL IS TO BE CHARGED ON A CREDIT CARD: THE ISSUER OF THE CARD IDENTIFIED ON THIS ITEM IS AUTHORIZED TO PAY THE AMOUNT SHOWN AS TOTAL UPON PROPER PRESENTATION. I PROMISE TO PAY SUCH TOTAL WITH ANY OTHER CHARGES DUE THEREON SUBJECT TO AND IN ACCORDANCE WITH THE AGREEMENT GOVERNING THE USE OF SUCH CARD.
        </li>
        <li>
          The following items listed below will be charged on your credit card:
          <ul style={{ marginLeft: '20px' }}>
            <li>Toll Violations</li>
            <li>Any damage on the vehicle</li>
            <li>Parking Violations</li>
          </ul>
        </li>
        <li>
Proceeding with this booking and making the payment shows that you have read & agreed to above mentioned terms and conditions.</li>
      </ol>
    </div>

         

            <div className="reserve-button" style={{paddingBottom:'30px'}}>
              <button 
                onClick={confirmBooking}
                style={{
                  backgroundColor: "#182b3a",
                  backgroundImage:
                    "linear-gradient(315deg, #182b3a 0%, #20a4f3 74%)", borderColor:'black'
                }}
              >
                 Book Now
              </button>

              
            </div>
          </form>
        </div>
      </div>

      {loading && (
        <div className="loader-overlay">
          <div className="loader-container">
            <div className="spinner"></div>
            Uploading images... Please wait
          </div>
        </div>
      )}
    </>
  );



  
}

export default BookCar;
